__turbopack_context__.v({
  "root": "ProductCardSupplements-module__w17yJa__root",
  "specBlock": "ProductCardSupplements-module__w17yJa__specBlock",
});
